import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ManagementOrdersInteractor } from "../iteractor/management.interactor";
import {
  ManagementOrdersRequest,
  UpdatedInstallationRequest, UpdatedTankRequest, UpdatedServWorkRequest,
  RemovedInstallationRequest, RemovedTankRequest, RemovedServWorkRequest, SendPdfEmailRequest
} from './interfaces/management.request';
import { ManagementOrdersResult } from "./interfaces/management.result";
import { IsRequestComplete } from '../../../../interfaces/isrequest-complete';
import { InstallationModel } from "src/app/models/orders/installation.model";
import { ServWorkModel } from '../../../../models/orders/servwork.model';
import { TankModel } from '../../../../models/orders/tank.model';
import { PdfMakeWrapper } from "pdfmake-wrapper";

@Injectable({providedIn:'root'})
export class ManagementOrdersPresenter implements ManagementOrdersRequest, ManagementOrdersResult,
UpdatedInstallationRequest, UpdatedTankRequest, UpdatedServWorkRequest,
RemovedInstallationRequest, RemovedTankRequest, RemovedServWorkRequest,
SendPdfEmailRequest, IsRequestComplete {

private result: ManagementOrdersResult;
private _isRequestComplete: IsRequestComplete;

constructor(private interactor: ManagementOrdersInteractor) {
  interactor.setPresenter(this);
}


setRequestCompleteComponent(isRequestComplete: IsRequestComplete){
  this._isRequestComplete = isRequestComplete;
}

setComponent(result: ManagementOrdersResult){
  this.result = result;
}

isRequestComplete(status: boolean, error?: HttpErrorResponse, data?: object | any[]): void {
 this._isRequestComplete.isRequestComplete(status, error, data);
}

getResponse(response: HttpResponse<any>): void {
  this.result.getResponse(response);
}

getOrders(page: number, limit: number , startDate?: Date, endDate?: Date, query?: string, status?: string): Promise<any[]> {
  return this.interactor.getOrders(page, limit, startDate, endDate, query, status);
}
exportOrdersExcel(startDate?: Date, endDate?: Date, query?: string, status?: string): Observable<Blob> {
  return this.interactor.exportOrdersExcel(startDate, endDate, query, status);
}
editInstallation(model: InstallationModel): void {
  this.interactor.editInstallation(model);
}
editServWork(model: ServWorkModel): void {
  this.interactor.editServWork(model);
}
editTank(model: TankModel): void {
  this.interactor.editTank(model);
}
deleteInstallation(id: string): void {
  this.interactor.deleteInstallation(id);
}
deleteTank(id: string): void {
  this.interactor.deleteTank(id);
}
deleteServWork(id: string): void {
  this.interactor.deleteServWork(id);
}
sendPdfEmail(pdf: PdfMakeWrapper, emailTemplate: string, fileName: string, images: File[]): Promise<boolean> {
   return this.interactor.sendPdfEmail(pdf, emailTemplate, fileName, images);
}
}
